
import SET_GLOBAL_PUSHER_INSTANCE from 'Redux/types/utilitiesTypes';


const initianState = {
  pusher: null,
};

const utilitiesReducer = (state = initianState, actions) => {
  switch (actions.type) {
    case SET_GLOBAL_PUSHER_INSTANCE:
      return ({
        ...state,
        pusher: actions.pusher,
      });
    default:
      return (state);
  }
};

export default utilitiesReducer;
